import React from 'react';
import { faBriefcase, faCloudDownloadAlt } from '@fortawesome/free-solid-svg-icons';
import { faHackerrank } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import jkTanzim from '../../../images/jk-tanzim.jpg';
import Flip from 'react-reveal/Flip';
import Fade from 'react-reveal/Fade';
import { faFacebookSquare, faGithubSquare, faLinkedin, faStackOverflow } from '@fortawesome/free-brands-svg-icons';
import resume from './Junaidul-Kader-Tanzim-Frontend-Developer-Resume-2022.pdf'

const HeroSection = () => {
    return (
        <div>
            <div className="row d-flex align-items-center text-white py-5">
                <div className="col-md-3">
                    <div>
                        <img className="rounded-circle img-fluid" src={jkTanzim} alt="" />
                    </div>
                </div>
                <div className="col-md-9">
                    <Flip top cascade>
                        <h2 className="fw-bold text-uppercase ">Junaidul Kader (Tanzim)</h2>
                    </Flip>

                    <p><FontAwesomeIcon icon={faBriefcase} /> Front-End Web Developer</p>


                    <p>15+ Modern web projects, 1 year of Experience</p>

                    <p className="fs-4">
                        <a href="https://www.linkedin.com/in/junaidul-kader/" className="me-3 cool-link-icon" title="Junaidul Kader LinkedIn" target="_blank" rel="noreferrer" ><FontAwesomeIcon icon={faLinkedin}></FontAwesomeIcon></a>
                        <a href="https://github.com/Tanzim395" className="me-3  cool-link-icon" title="Junaidul Kader GitHub" target="_blank" rel="noreferrer" ><FontAwesomeIcon icon={faGithubSquare}></FontAwesomeIcon></a>
                        <a href="https://stackoverflow.com/users/16609657/tanzim395" title="Junaidul Kader Stackoverflow" className="me-3  cool-link-icon" target="_blank" rel="noreferrer" ><FontAwesomeIcon icon={faStackOverflow}></FontAwesomeIcon></a>
                        <a href="https://facebook.com/tanzim.khan.12" title="Tanzim on Facebook" className="me-3  cool-link-icon" target="_blank" rel="noreferrer" ><FontAwesomeIcon icon={faFacebookSquare}></FontAwesomeIcon></a>
                        <a href="https://www.hackerrank.com/junaidulkader" title="Tanzim on HackerRank" className="me-3  cool-link-icon" target="_blank" rel="noreferrer" ><FontAwesomeIcon icon={faHackerrank}></FontAwesomeIcon></a>
                    </p>


                    <div>
                        <a href={resume} download="resume.pdf" className="btn btnDwnResume me-2 mb-2 mb-md-0">
                            <FontAwesomeIcon icon={faCloudDownloadAlt} /> Download Resume
                        </a>

                    </div>
                </div>
            </div>

            <Fade bottom cascade>
                <div className="">
                    <span>
                        <small>
                            <h1 className="text-white text-center hero-section">
                                Welcome to my <span className="text-danger">Portfolio Website</span>
                            </h1>
                        </small>
                    </span>
                </div>
            </Fade>

        </div>
    );
};

export default HeroSection;